import React, { useState, useRef } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import useTooltipClickOutside from 'utils/hooks/useTooltipClickOutside';
import * as Styled from './AdditionalInformation.styled';

interface AdditionalInformationProps {
  description: string;
  color?: string;
}

const AdditionalInformation: React.FC<AdditionalInformationProps> = ({
  description,
  color,
}) => {
  const [tooltipVisibility, setTooltipVisibility] = useState<{
    [key: string]: boolean;
  }>({
    additionalInfo: false,
  });

  useTooltipClickOutside({
    tooltipVisibility,
    setTooltipVisibility,
  });

  const handleOpenChange = (newOpen: boolean) => {
    setTooltipVisibility({ additionalInfo: newOpen });
  };

  const content = (
    <Styled.PopoverComponent>
      <p>{description}</p>
    </Styled.PopoverComponent>
  );

  return (
    <Styled.PopoverIconMark>
      <Popover
        content={content}
        trigger={['click']}
        placement="topLeft"
        overlayStyle={{ width: '200' }}
        open={tooltipVisibility.additionalInfo}
        onOpenChange={handleOpenChange}
      >
        <Styled.QuestionIcon color={color} />
      </Popover>
    </Styled.PopoverIconMark>
  );
};

export default AdditionalInformation;
